/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { compose } from 'ramda';
import ui from 'redux-fui';
import ConnectedHeader from '../components/Global/Header';
import Footer from '../components/Global/Footer';
import { load as loadAuth } from '../stores/auth';
import { load as loadFeatures } from '../stores/features';
import config from '../../config/config';
import safelyHoistStatics from '../helpers/safelyHoistStatics';
import withoutAppBanner from '../helpers/config';
import withQueryParams from './withQueryParams';

class App extends Component {
  static fetchData(store, match, query, fingerprint) {
    // First check auth, then pass this response to feature flagging
    return store
      .dispatch(loadAuth())
      .then(user =>
        store.dispatch(loadFeatures(user, fingerprint)).then(() => user)
      );
  }

  componentDidMount() {
    if (__CLIENT__ && document.documentElement) {
      // We have JS if this can run
      document.documentElement.classList.remove('no-js');
    }
  }

  render() {
    const className = `${
      this.props.queryParams.standalone ? 'standalone' : ''
    }`;
    const { standalone } = this.props.queryParams;

    const appBannerDisabledPages = ['/search', '/searchresultsnew'];

    const helmetConfig =
      appBannerDisabledPages.indexOf(this.props.location.pathname) !== -1
        ? withoutAppBanner(config)
        : config;

    return (
      <div className={className}>
        <div id="portal" />
        <Helmet {...helmetConfig.app.head} />
        {!standalone && <ConnectedHeader user={this.props.user} />}
        {renderRoutes(this.props.route.routes)}
        {!standalone && <Footer />}
      </div>
    );
  }
}

App.propTypes = {
  user: PropTypes.object,
  location: PropTypes.object,
  route: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ user: state.auth.user });

const appComposition = compose(
  withRouter,
  ui({
    key: 'app',
    state: {
      headerShouldShowCTA: false,
      animateSearchForm: false
    }
  }),
  connect(mapStateToProps),
  withQueryParams
)(App);

export default hot(module)(safelyHoistStatics(appComposition, App));
